/** Renders `text` with every case-insensitive occurrence of `term` wrapped in <mark>. */
export default function Highlight({ text, term }: { text: string; term?: string }) {
  const t = (term ?? "").trim();
  if (!t) return <>{text}</>;
  const parts = text.split(new RegExp(`(${t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi"));
  return (
    <>
      {parts.map((p, i) =>
        p.toLowerCase() === t.toLowerCase()
          ? <mark key={i} className="bg-warning-soft text-foreground rounded px-0.5">{p}</mark>
          : <span key={i}>{p}</span>,
      )}
    </>
  );
}
